import { useEffect, useState } from 'react';
import IGridComponent from '../../../components/grid/i-grid.component';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IButton from '../../../components/button/i-button.component';
import { Box } from '@mui/system';

const OutputSplitComponent = (props: any) => {
  const rows: GridRowsProp = [];
  const [splitRows, setSplitRows] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'code', headerName: 'Code', width: 120 },
    { field: 'outputSplit', headerName: 'Output Split (%)', width: 120, editable: true, type: 'number' },
  ];

  useEffect(() => {
    let rows: any = []
    let values: any[] = props.data.outputSplit.split(',');
    
    values.forEach((element, index) => {
      rows.push({id: index + 1, code: element.split('=')[0], outputSplit: 'null' === element.split('=')[1] ? '' : element.split('=')[1]});
    });

    setSplitRows(rows);
  }, []);

  const onOk = () => {
    let value: string = '';
    for(let i = 0; i < splitRows.length; ++i) {
      value += splitRows[i].code + '=' + splitRows[i].outputSplit + ','
    }
    
    props.data.outputSplit = value.substring(0, value.length - 1)
    props.close();
  }

  const onCancel = () => {
    props.close();
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    splitRows[updatedRow.id - 1].outputSplit = updatedRow.outputSplit;
  }

  return <>
    <IGridComponent title='' rows={splitRows} columns={columns} processRowUpdate={processRowUpdate}
      hideFooter={true} hideFooterPagination={true} getRowId={(row: any) => row.id}/>
    <Box display="flex" justifyContent="center" width="100%" mt={2}>
      <IButton name='submit' label='Submit' color="primary" onActionEvent={onOk}/>
      <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
    </Box>
  </>
}

export default OutputSplitComponent;